import { useEffect, useState } from "react"
import classNames from "classnames"

const Text = ({entity, name, valueGetter=null, textSize="medium", indentAttr=null}) => {
    const [value, setValue] = useState(null)
    const [error, setError] = useState(null)

    useEffect(
        () => {
            if (!value) {
                const val = (!!valueGetter) ? valueGetter(entity, name) : entity[name]
                if (!val) {
                    setValue("")
                    setError("item no longer exists")
                } else {
                    setValue(val)
                    setError(null)
                }
            }
        }, [entity, name, value, valueGetter]
    )

    if (!value) {
        return (<span></span>)
    }

    return (
        <>
        <span style={{
                fontSize: textSize,
                paddingLeft: (!indentAttr) ? 0 : `${entity[indentAttr] * 20}px`
            }}>
            {value}
        </span>
        <br />
        <span className={classNames("err-msg", {"hidden": !error})}>
            {error}
        </span>
        </>
    )
}

export default Text

